export default "__VITE_ASSET__C2Hil4Rw__ 1920w";